export default "__VITE_ASSET__B3wVRfE6__"